import { Check } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1660330589693-99889d60181e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmd8ZW58MHx8fHwxNzg3NTAyODI1fDA&ixlib=rb-4.1.0&q=85";

const points = [
  "Local, one-team service — you deal with the same electrician throughout",
  "Honest advice: if something doesn't need doing, we'll say so",
  "Written quotes before work begins, so there's no guesswork",
];

const About = () => (
  <section id="about" data-testid="about-section" className="bg-white py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <Reveal className="relative order-2 lg:order-1">
        <div className="absolute -bottom-5 -left-5 w-full h-full rounded-tl-[4rem] rounded-br-[4rem] bg-blue-600 hidden sm:block" aria-hidden="true" />
        <div className="relative overflow-hidden rounded-tl-[4rem] rounded-br-[4rem] aspect-[4/5] max-h-[520px] w-full">
          <img
            src={ABOUT_IMG}
            alt="Electrician working on a modern electrical consumer unit"
            data-testid="about-image"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      </Reveal>

      <Reveal className="order-1 lg:order-2">
        <Overline>About us</Overline>
        <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
          A local electrician you can actually get hold of
        </h2>
        <p className="mt-6 text-base md:text-lg leading-relaxed text-slate-600">
          Essex Spark Electrical is a local electrical service helping
          homeowners, landlords and businesses across Basildon and the
          surrounding Essex towns. We're a small, hands-on operation — the
          person who quotes your job is the person who turns up to do it.
        </p>
        <p className="mt-4 text-base md:text-lg leading-relaxed text-slate-600">
          Most of our work comes from repeat customers and word of mouth, and
          we'd like to keep it that way. That means turning up on time, doing
          the job properly and leaving your place tidy.
        </p>
        <ul className="mt-8 space-y-4" data-testid="about-points">
          {points.map((p) => (
            <li key={p} className="flex items-start gap-3 text-sm md:text-base font-medium text-slate-700">
              <span className="mt-0.5 w-5 h-5 shrink-0 bg-amber-400 rounded-sm flex items-center justify-center">
                <Check className="w-3.5 h-3.5 text-slate-900" strokeWidth={3} />
              </span>
              {p}
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);

export default About;
